document.addEventListener('DOMContentLoaded', function() {
  const headings = document.querySelectorAll('.footer-block__heading');

  headings.forEach(heading => {
    heading.addEventListener('click', function() {
      if (window.innerWidth <= 749) {
        const parent = heading.parentNode;
        const detailsContents = parent.querySelectorAll('.footer-block__details-content');
        detailsContents.forEach(detailsContent => {
          detailsContent.style.display = detailsContent.style.display === 'block' ? 'none' : 'block';
        });
      }
    });
  });
});

